import { Box } from '@chakra-ui/react'
import React, { Fragment } from 'react'
import { PasswordListErrorProps } from './interface'
import { ListError } from './styles'

const PasswordListError: React.FC<PasswordListErrorProps> = ({ password }) => {
    const boxs = [
        {
            match: 'min',
            text: 'Mínimo 8 digitos',
            regex: /^.{8,}$/
        },
        {
            match: 'uppercase',
            text: 'Letra maiúscula',
            regex: /(?=.*[A-Z])/
        },

        {
            match: 'lowercase',
            text: 'Letra minúscula',
            regex: /(?=.*[a-z])/
        },
        {
            match: 'numeric',
            text: 'Número',
            regex: /(?=.*[0-9])/
        },
        {
            match: 'special',
            text: 'Símbolo',
            regex: /(?=.*\W|_)/
        }
    ]
    return (
        <ListError
            data-testid={`password-error-list`}
            key={`password-error-list`}
            color="gray.400"
        >
            {boxs.map(({ text, regex, match }, index) => (
                <Fragment key={`password-error-item-${match}`}>
                    {index ? '•' : ''}
                    <Box
                        data-testid={`password-error-item-${match}`}
                        key={`password-error-item-${match}`}
                        data-status={String(!!password?.match(regex))}
                        color={
                            password === ''
                                ? ''
                                : password?.match(regex)
                                ? 'green.500'
                                : 'red.500'
                        }
                    >
                        {text}
                    </Box>
                </Fragment>
            ))}
        </ListError>
    )
}

export default PasswordListError
